import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import ListCustomerJourneyTab from "./ListCustomerJourneyTab";
import SearchCustomerJourneyTab from "./SearchCustomerJourneyTab";
import { transformDate } from "app/common/LocalFunction";
import moment from "moment";
import * as Yup from "yup";
import FilterListIcon from "@material-ui/icons/FilterList";

const CustomerJourneyTabIndex = ({ tabValue }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  let [isOpenFillter, setOpenFillter] = useState(true);

  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });

  const { searchCustomerJourney, handleChangeFormSearchService } =
    useStore().patientManagementStore.customerJourneyTabStore;

  const { initialPatient, listVatPercent } =
    useStore().patientManagementStore.patientGeneralStore;
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearchService({
        ...searchCustomerJourney,
        patientId,
        fromDate: null,
        toDate:null,
      });
    }
  }, [patientId]);
  return (
    <section className="form-patient " style={{ margin: "4px" }}>
      <div style={{ backgroundColor: "#bdfff342" }}>
        <Formik
          initialValues={searchCustomerJourney}
          validationSchema={searchPatientValidationSchema}
          onSubmit={(values) => {
            handleChangeFormSearchService(values);
          }}
          enableReinitialize
        >
          {({ values }) => {
            return (
              <Form autoComplete="off">
                <>
                  <div
                    className=" flex justify-between gap-2"
                    style={{ fontSize: "16px" }}
                  >
                    <p className="cards-header flex">
                      <span
                        className="flex items-center pointer"
                        style={{ fontWeight: "bold" }}
                      >
                        Hành trình khách hàng
                      </span>
                      <span
                        style={{ cursor: "pointer" }}
                        className="flex items-center"
                        onClick={() => setOpenFillter(!isOpenFillter)}
                      >
                        <FilterListIcon color="red" />
                      </span>
                    </p>
                  </div>

                  {!isOpenFillter && (
                    <>
                      <style>
                        {`
                    @keyframes slideDownFade {
                      0% {
                        opacity: 0;
                        transform: translateY(-10px);
                      }
                      100% {
                        opacity: 1;
                        transform: translateY(0);
                      }
                    }
                  `}
                      </style>
                      <div
                        style={{
                          animation: "slideDownFade 0.3s ease forwards",
                          zIndex: 10,
                          position: "relative",
                        }}
                      >
                        <SearchCustomerJourneyTab />
                      </div>
                    </>
                  )}

                  <ListCustomerJourneyTab />
                </>
              </Form>
            );
          }}
        </Formik>
      </div>
    </section>
  );
};

export default memo(observer(CustomerJourneyTabIndex));
